<template>
  <div>
    <div class="panel">
      <div class="dialog-group-title">选择打印模板</div>
      <el-form label-width="80px">
        <el-row>
          <el-col :span="24">
              <el-form-item label="请选择" prop="orderCode">
                <el-select
                    size="small"
                      v-model="printTemplate"
                      clearable
                      placeholder="请选择"
                      style="width:100%;"

                      @change="templateChange"

                  >
                      <el-option
                      v-for="item in printTemplateList"
                      :key="item._id"
                      :label="item.name"
                      :value="item._id"
                      ></el-option>
                  </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div class="dialog-group-title">预览</div>
        <div id="printArea" ref="printArea">


          <table style="width:100%;" align="left"  cellspacing="0" class="printTbl">
          <tr>
            <td colspan="2">
              <span style="font-size: 16px;color: red;font-weight: bold;">{{factory.factoryName + '——任务单'}}</span>
            </td>
            <td rowspan="12">
              <img :src="imgBase64" />
            </td>
          </tr>
          <tr v-if="printData['orderCode']">
            <td>
              <span style="font-size: 16px;color: red;">工单编号</span>
            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['orderCode']}}</span>
            </td>
          </tr>
          <tr v-if="printData['product.productCode']">
            <td>
              <span style="font-size: 16px;color: red;">产品编号</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['product.productCode']}}</span>
            </td>
          </tr>
          <tr v-if="printData['product.productName']">
            <td>
              <span style="font-size: 16px;color: red;">产品名称</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['product.productName']}}</span>
            </td>
          </tr>

          <tr v-if="printData['product.specs']">
            <td>
              <span style="font-size: 16px;color: red;">产品规格</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['product.specs']}}</span>
            </td>
          </tr>
          <tr v-if="printData['orderStatus']">
            <td>
              <span style="font-size: 16px;color: red;">状态</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['orderStatus']}}</span>
            </td>
          </tr>


          <tr v-if="printData['priority']">
            <td>
              <span style="font-size: 16px;color: red;">优先级</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['priority']}}</span>
            </td>
          </tr>
          <tr v-if="printData['relateDoc']">
            <td>
              <span style="font-size: 16px;color: red;">关联单据</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['relateDoc']}}</span>
            </td>
          </tr>
          <tr v-if="printData['planStartTime']">
            <td>
              <span style="font-size: 16px;color: red;">计划开始时间</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['planStartTime']}}</span>
            </td>
          </tr>
          <tr v-if="printData['planEndTime']">
            <td>
              <span style="font-size: 16px;color: red;">计划结束时间</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['planEndTime']}}</span>
            </td>
          </tr>
          <tr v-if="printData['planNum']">
            <td>
              <span style="font-size: 16px;color: red;">计划数</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['planNum']}}</span>
            </td>
          </tr>
          <tr v-if="printData['actualStartTime']">
            <td>
              <span style="font-size: 16px;color: red;">实际开始时间</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['actualStartTime']}}</span>
            </td>
          </tr>
          <tr v-if="printData['actualEndTime']">
            <td>
              <span style="font-size: 16px;color: red;">实际结束时间</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['actualEndTime']}}</span>
            </td>
          </tr>
          <tr v-if="printData['remark']">
            <td>
              <span style="font-size: 16px;color: red;">备注</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData['remark']}}</span>
            </td>
          </tr>

          <tr v-if="printData.creater">
            <td>
              <span style="font-size: 16px;color: red;">创建人</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.creater}}</span>
            </td>
          </tr>
          <tr v-if="printData.createTime">
            <td>
              <span style="font-size: 16px;color: red;">创建时间</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.createTime}}</span>
            </td>
          </tr>
          <tr v-if="printData.updateTime">
            <td>
              <span style="font-size: 16px;color: red;">更新时间</span>

            </td>
            <td>
              <span style="font-size: 16px;color: #000;">{{printData.updateTime}}</span>
            </td>
          </tr>

          </table>
        </div>





    </div>
    <div class="panel-bottom">
         <el-button size="small" type="default"  @click="closeDialog">关闭</el-button>
         <el-button size="small" type="primary"  v-print="'#printArea'" >打印</el-button>
     </div>
  </div>
  </template>
  <script>
 import { queryPrintTemplateAll,printPreview,savePrintTemplate,queryFactoryById} from '@/api/business';


  export default {
   name:'PrintLayout',

   props:{
       userData:{
         type:Object,
         default:{},
       },

       editRow:{
           type:Object,

           default:{}
       },
       type:{
        type:String,
        default:''
       }


   },
   watch:{


       editRow:{
          handler(newVal) {

              if(newVal){
                  this.form = JSON.parse(JSON.stringify(newVal));

              }
          },
          deep: true,
          immediate: true
        }
   },
   data(){
       return{
        printTemplateList:[],
        printTemplate:'',
        form:{},
        channelForm:{
          selectedChannelList:[
            {text:'123'},
            {text:'456'},
            {text:'789'},
          ],
          selectedChannelListindex:[],
        },
        imgBase64:'',
        printData:[],
        factory:{},

       }
   },
   created(){
    if(this.userData){
      this.form.factoryId = this.userData.factoryId;
      this.init();

    }
   },
   methods:{
    templateChange(val){
      printPreview(this.form._id,val).then(res=>{
        if(res.code==200){
          this.imgBase64 = 'data:image/png;base64,'+ res.data.base64;
          this.printData = res.data.content;
        }
      })
    },
    init(){
      queryFactoryById(this.userData.factoryId).then(res1=>{
        if(res1.code == 200){
          this.factory = res1.data;

        }
      });
      queryPrintTemplateAll(this.userData.factoryId,this.type).then(res=>{
        if(res.code == 200){
          this.printTemplateList = res['data'];
          this.printTemplate = res['data'][0]._id;

          printPreview(this.form._id,this.printTemplate).then(res=>{
            if(res.code==200){
              this.imgBase64 = 'data:image/png;base64,'+ res.data.base64;
              this.printData = res.data.content;

            }
          })
        }
      });
    },
    deleteRow (index, e, type) {
        if (type === 'up') {
          if (index === 0){

            return;
          }
          //在上一项插入该项
          this.channelForm.selectedChannelList.splice(index - 1, 0, (this.channelForm.selectedChannelList[index]));// 删除后一项
          this.channelForm.selectedChannelList.splice(index + 1, 1);
        } else if (type === 'down') {
          if (index === (this.channelForm.selectedChannelList.length - 1)){

            return;
          }
          this.channelForm.selectedChannelList.splice(index + 2,0,(this.channelForm.selectedChannelList[index]));
          this.channelForm.selectedChannelList.splice(index,1);
        }
    },

    handlePrint(){
      var oldHtml = window.document.body.innerHTML;
      var newHtml = window.document.getElementById('printArea').innerHTML;
      window.document.body.innerHTML = newHtml;
      window.print();
      window.document.body.innerHTML = oldHtml;

    },

    closeDialog(){
      this.$emit('done',{type:'cancel'})
    },
   }

  }
  </script>
  <style>
   .panel{
       overflow-y: auto;
       overflow-x: hidden;
   }

   .panel-bottom{
       width: 100%;
       height: 40px;
       line-height: 40px;
       padding-top: 20px;
       text-align: center;
   }
   .panel-bottom el-button{
       margin: 10px 0 0 10px;
   }
   .printTbl {
        border-right: 1px solid #000000;
        border-bottom: 1px solid #000000;
        text-align: center;
    }

    .printTbl th {
        border-left: 1px solid #000000;
        border-top: 1px solid #000000;
    }

    .printTbl td {
        border-left: 1px solid #000000;
        border-top: 1px solid #000000;
    }
  </style>



// WEBPACK FOOTER //
// src/views/order/PrintLayout.vue